export default __webpack_public_path__ + "static/media/technology_center.73c1f6db.png";